<template>
    <div class="a-modal">
        <div class="popup__header popup__header--inline popup__header--border">
            <span class="title title--sm popup__title">{{ $lang('partnerData.title') }}</span>
            <div class="a-popup__partner-code">
                <span class="a-popup__partner-code-name">{{ $lang('partnerData.code') }}</span>
                <span class="a-popup__partner-code-value">{{ partnerCode }}</span>
            </div>
        </div>
        <form class="form" ref="form" @submit.prevent="submit">
            <div class="popup__content">
                <remote-host v-if="form.partner_id" :partner-id="form.partner_id" :enabled-reset-form="false"></remote-host>

<!--                Скрываем до того момента пока не закончим реализацию всей задачи
                <remote-db v-if="form.partner_id" :partner-id="form.partner_id" ></remote-db>-->

                <div class="form__item">
                    <div class="a-modal__small">
                        <span class="form__label">{{ $lang('partnerData.commission') }}</span>
                        <el-popover v-model="errors.commission.isError"
                                    trigger="manual"
                                    placement="top"
                                    width="300"
                                    popper-class="add__error-popover"
                                    :content="errors.commission.message">
                            <el-input slot="reference" :class="{ 'add__error': errors.commission.isErrorPaint}"
                                      @focus="clearErrors"
                                      :placeholder="$lang('partnerData.commission.placeholder')" class="input input--small" v-model="form.commission"
                                      :readonly="true"></el-input>
                        </el-popover>
                    </div>
                </div>
                <div class="form__item form__item--inline">
                    <label class="form__inner">
                        <span class="form__label">{{ $lang('partnerData.phone') }}</span>
                        <el-popover :value="errors.phone.isError || errors.phone_md5.isError"
                                    trigger="manual"
                                    placement="top"
                                    width="300"
                                    popper-class="add__error-popover"
                                    :content="errors.phone.message || errors.phone_md5.message">
                            <div slot="reference">
                                <input-phone-by-country id="phone"
                                                        v-model="form.phone"
                                                        @isValid="$event => this.isValidPhone = $event"
                                                        @focus="clearErrors"
                                                        :fetch-country="fetchCountry"
                                                        :placeholder="$lang('partnerData.phone.placeholder')"/>
                            </div>
                        </el-popover>
                    </label>
                    <label class="form__inner">
                        <span class="form__label">{{ $lang('partnerData.email') }}</span>
                        <el-popover :value="errors.email.isError || errors.email_md5.isError"
                                    trigger="manual"
                                    placement="top"
                                    width="300"
                                    popper-class="add__error-popover"
                                    :content="errors.email.message || errors.email_md5.message">
                            <el-input slot="reference" :class="{ 'add__error': errors.email.isErrorPaint || errors.email_md5.isErrorPaint }"
                                      @focus="clearErrors"
                                      :placeholder="$lang('partnerData.email.placeholder')" class="input input--big" v-model="form.email"></el-input>
                        </el-popover>
                    </label>
                </div>
                <div class="form__item a-modal__separator">
                    <span class="form__label">{{ $lang('partnerData.name') }}</span>
                    <el-popover v-model="errors.name.isError"
                                trigger="manual"
                                placement="top"
                                width="300"
                                popper-class="add__error-popover"
                                :content="errors.name.message">
                        <el-input slot="reference" :class="{ 'add__error': errors.name.isErrorPaint }"
                                  @focus="clearErrors"
                                  :placeholder="$lang('partnerData.name.placeholder')" class="input input--big"
                                  v-model="form.name"></el-input>
                    </el-popover>
                </div>
                <span class="form__item a-modal__description">
                    {{ $lang('partnerData.paymentData') }}
                </span>
                <label class="form__item a-modal__big">
                    <span class="form__label">{{ $lang('partnerData.inn') }}</span>
                    <el-popover v-model="errors.payment_details.inn.isError"
                                trigger="manual"
                                placement="top"
                                width="300"
                                popper-class="add__error-popover"
                                :content="errors.payment_details.inn.message">
                        <el-input slot="reference" :class="{ 'add__error': errors.payment_details.inn.isErrorPaint }"
                                  @focus="clearErrors"
                                  placeholder="1111111111" class="input input--big"
                                  v-model="form.payment_details.inn"></el-input>
                    </el-popover>
                </label>
                <label class="form__item a-modal__big">
                    <span class="form__label">{{ $lang('partnerData.address') }}</span>
                    <el-popover v-model="errors.payment_details.address.isError"
                                trigger="manual"
                                placement="top"
                                width="300"
                                popper-class="add__error-popover"
                                :content="errors.payment_details.address.message">
                        <el-input slot="reference"
                                  :class="{ 'add__error': errors.payment_details.address.isErrorPaint }"
                                  @focus="clearErrors"
                                  :placeholder="$lang('partnerData.address.placeholder')" class="input input--big"
                                  v-model="form.payment_details.address"></el-input>
                    </el-popover>
                </label>
                <label class="form__item a-modal__big">
                    <span class="form__label">{{ $lang('partnerData.bik') }}</span>
                    <el-popover v-model="errors.payment_details.bik.isError"
                                trigger="manual"
                                placement="top"
                                width="300"
                                popper-class="add__error-popover"
                                :content="errors.payment_details.bik.message">
                        <el-input slot="reference" :class="{ 'add__error': errors.payment_details.bik.isErrorPaint }"
                                  @focus="clearErrors"
                                  placeholder="1111111111" class="input input--big"
                                  v-model="form.payment_details.bik"></el-input>
                    </el-popover>
                </label>
                <div class="form__item a-modal__big">
                    <span class="form__label">{{ $lang('partnerData.rc') }}</span>
                    <el-popover v-model="errors.payment_details.r_c.isError"
                                trigger="manual"
                                placement="top"
                                width="300"
                                popper-class="add__error-popover"
                                :content="errors.payment_details.r_c.message">
                        <el-input slot="reference" :class="{ 'add__error': errors.payment_details.r_c.isErrorPaint }"
                                  @focus="clearErrors"
                                  placeholder="1111111111" class="input input--big"
                                  v-model="form.payment_details.r_c"></el-input>
                    </el-popover>
                </div>
                <label class="form__item a-modal__big">
                    <span class="form__label">{{ $lang('partnerData.kc') }}</span>
                    <el-popover v-model="errors.payment_details.k_c.isError"
                                trigger="manual"
                                placement="top"
                                width="300"
                                popper-class="add__error-popover"
                                :content="errors.payment_details.k_c.message">
                        <el-input slot="reference" :class="{ 'add__error': errors.payment_details.k_c.isErrorPaint }"
                                  @focus="clearErrors"
                                  placeholder="1111111111" class="input input--big"
                                  v-model="form.payment_details.k_c"></el-input>
                    </el-popover>
                </label>
                <label class="form__item a-modal__separator">
                    <div class="a-modal__big">
                        <span class="form__label">{{ $lang('partnerData.user') }}</span>
                        <el-popover v-model="errors.payment_details.signer.isError"
                                    trigger="manual"
                                    placement="top"
                                    width="300"
                                    popper-class="add__error-popover"
                                    :content="errors.payment_details.signer.message">
                            <el-input slot="reference"
                                      :class="{ 'add__error': errors.payment_details.signer.isErrorPaint }"
                                      @focus="clearErrors"
                                      :placeholder="$lang('partnerData.user.placeholder')" class="input input--big"
                                      v-model="form.payment_details.signer"></el-input>
                        </el-popover>
                    </div>
                </label>
                <div class="form__item a-modal__separator a-modal__password">
                    <div class="a-modal__password-header">
                        <span class="a-modal__password-title">{{ $lang('partnerData.password.title') }}</span>
                        <button class="btn link" :disabled="disableSetPassword" @click.prevent="reset"><span>{{ $lang('partnerData.password.button') }}</span>
                        </button>
                    </div>
                    <div class="a-modal__password-description">
                        {{ $lang('partnerData.password.desc') }}
                    </div>
                </div>
                <edit-referral v-if="loaded && form.referral_enabled"
                               :referral-slug="form.referral_slug"
                               :referral-commission.sync="form.referral_commission"
                               :referral-enabled.sync="form.referral_enabled"
                               :referral-link-enabled.sync="form.referral_link_enabled"
                               :locale="form.locale"
                               :domains="form.domains"
                               :partner-id="form.partner_id"
                >
                </edit-referral>
            </div>
            <div class="popup__footer">
                <button class="btn btn--middle btn--main-bg">{{ $lang('partnerData.save') }}</button>
                <button type="button" class="btn btn--middle btn--link" @click="close">{{ $lang('partnerData.cancel') }}</button>
            </div>
        </form>
    </div>
</template>

<script>
import {mapActions, mapMutations} from 'vuex';
import validator from "../../mixins/validator";
import userEdit from "../../mixins/userEdit";
import InputPhone from "../../components/InputPhone";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import helper from "../../mixins/helper";
import RemoteHost from "../remote/Host";
import RemoteDb from "../remote/Db";
import EditReferral from "../admin/partner/EditReferral";
import InputPhoneByCountry from "../../components/InputPhoneByCountry";


export default {
    name: "PartnerProfile",
    mixins: [userEdit, helper, validator],
    components: {VueCropper, RemoteHost, EditReferral, RemoteDb, InputPhone, InputPhoneByCountry},
    data: () => ({
        loaded: false,
        form: {
            name: '',
            phone: '',
            email: '',
            partner_id: '',
            commission: '',
            payment_details: {
                inn: '',
                address: '',
                bik: '',
                r_c: '',
                k_c: '',
                signer: ''
            },
            referral_slug: null,
            referral_commission: 0,
            referral_enabled: false,
            locale: 'ru',
        },
        fetchCountry: false,
        isValidPhone: true,
        rules: {
            phone: {
                validator: (rule, value, cb) => {
                    cb()
                }
            },
        },
        errors: {
            name: {
                isError: false,
                message: ''
            },
            email: {
                isError: false,
                message: ''
            },
            phone: {
                isError: false,
                message: ''
            },
            email_md5: {
                isError: false,
                message: ''
            },
            phone_md5: {
                isError: false,
                message: ''
            },
            commission: {
                isError: false,
                message: ''
            },
            payment_details: {
                inn: {isError: false, message: ''},
                address: {isError: false, message: ''},
                bik: {isError: false, message: ''},
                r_c: {isError: false, message: ''},
                k_c: {isError: false, message: ''},
                signer: {isError: false, message: ''},
            },
        },
        disableSetPassword: false,
        locale: window.laravel.locale
    }),
    computed: {
        partnerCode: function () {
            var text = this.form.partner_id + '';

            while (text.length < 7) {
                text = '0' + text;
            }

            return text;
        }
    },
    mounted() {
        this.getProfile()
            .then((response) => {
                this.setData(
                    'form',
                    ['name', 'email', 'phone', 'partner_id', 'payment_details', 'commission', 'referral_slug',
                        'referral_commission', 'referral_enabled', 'locale', 'domains', 'referral_link_enabled'],
                    response.data,
                    ['name', 'email', 'phone', 'partner_data.id', 'partner_data.payment_details',
                        'partner_data.commission', 'partner_data.referral_slug', 'partner_data.referral_commission',
                        'partner_data.referral_enabled', 'partner_data.locale', 'partner_data.domains', 'partner_data.referral_link_enabled']
                );

                this.loaded = true;

                if (!this.form.phone) {
                    this.fetchCountry = true;
                }
            });

        this.loaded = true;
    },
    methods: {
        ...mapActions('miniProfile', [
            'getProfile',
            'editProfile',
            'resetPassword',
        ]),
        ...mapMutations('auth', [
            'setUser',
        ]),
        submit() {
            this.rules.phone.validator = (rule, value, cb) => {
                this.isValidPhone || value === null
                    ? cb()
                    : cb(new Error(Vue.prototype.$lang('miniProfile.invalidPhone')));
            };

            this.validate(() => {
                    this.$loading(this.$optionsLoading);

                    this.editProfile(this.form)
                        .then((response) => {
                            this.setUser(response.data);

                            this.$appNotify.success(Vue.prototype.$lang('partnerData.saved1'));

                            this.$router.go(-1);
                        })
                        .catch((error) => {
                            this.createErrors(error.response.data.errors);
                        })
                        .finally(() => {
                            this.$loading({}).close();
                        });
                },
                this.form
            );
        },
        reset() {
            if (!this.form.email && this.locale !== 'ru') {
                this.$appNotify.error(this.$lang('partnerData.sendPassword.emailRequired'));

                return this.errors.email = {
                    isError: true,
                    message: this.$lang('partnerData.sendPassword.emailRequired')
                }
            }

            this.$loading(this.$optionsLoading);

            this.disableSetPassword = true;

            this.resetPassword()
                .then((response) => {
                    this.$appNotify.success(Vue.prototype.$lang('partnerData.passwordReset'));
                })
                .catch((error) => {
                    this.createErrors(error.response.data.errors);
                })
                .finally(() => {
                    this.$loading({}).close();
                    this.disableSetPassword = false;
                });
        },
        close() {
            this.$router.go(-1);
        }
    }
}
</script>
